import { shipmentInfoService } from '@/services/shipmentInfo.service'

// Optional dashboard filters, enabled per company
// A filter is shown only when its key is listed in the EXTRA_FILTERS company parameter
export const EXTRA_FILTERS_PARAM = 'EXTRA_FILTERS'

export const EXTRA_FILTERS = {
  etdFrom: {
    type: 'date',
    label: 'label.etdFrom',
    icon: 'mdi-calendar',
  },
  etdTo: {
    type: 'date',
    label: 'label.etdTo',
    icon: 'mdi-calendar',
  },
  etaFrom: {
    type: 'date',
    label: 'label.etaFrom',
    icon: 'mdi-calendar',
  },
  etaTo: {
    type: 'date',
    label: 'label.etaTo',
    icon: 'mdi-calendar',
  },
  departureVessel: {
    type: 'select',
    label: 'label.departureVessel',
    icon: 'mdi-ferry',
    loadItems: shipmentInfoService.getDepartureVessels,
  },
  arrivalVessel: {
    type: 'select',
    label: 'label.arrivalVessel',
    icon: 'mdi-ferry',
    loadItems: shipmentInfoService.getArrivalVessels,
  },
}

export function resolveExtraFilters(paramValue, userAuthorizations = []) {
  if (!paramValue) return []
  return paramValue
    .split(',')
    .map((key) => key.trim())
    .filter((key) => EXTRA_FILTERS[key])
    .filter((key) => !EXTRA_FILTERS[key].auth || userAuthorizations.includes(EXTRA_FILTERS[key].auth))
}
